<div class="main-body" [class.privacy-mode]="isPrivacyMode">
	<div class="grid-stack" [hidden]="!gridReady" #gridContainer>
		<!-- All widgets will be created dynamically by GridStack -->
	</div>
</div>